import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const DigestsPage = lazy(() => import('./index'));

function DigestsOldPageLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <DigestsPage {...props} />
        </Suspense>
    );
}

export default DigestsOldPageLazy;
export { DigestsOldPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/laws-digests-old-page/lazy.js